import { Component, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'

import { environment } from '../../../environments/environment'
import { Overview } from './overview.model'
import { OverviewService } from './overview.service'

@Component({
  selector: 'overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  overviewModel: Overview
  stringModel: string
  overviewSubscription: Subscription
  perfArray: Array<any>
  literatureLink: string
  constructor(private readonly overviewService: OverviewService) {}

  ngOnInit() {
    this.overviewSubscription = this.overviewService
      .getModelData()
      .subscribe((model) => {
        this.overviewModel = model
        this.literatureLink = environment.externalUrl.concat(
          `us/FundsEProspectus?CUSIP=${this.overviewModel.cusip}&calledFrom=FundsApp&cbdForceDomain=true`,
        )
        this.stringModel = JSON.stringify(model)
        this.perfArray = [
          this.overviewModel?.ytdMarket,
          this.overviewModel?.ytdAsOfDate,
        ]
      })
  }
  ngOnDestroy(): void {
    this.overviewSubscription.unsubscribe()
  }
}
